import { render } from "./TheContactPage.vue?vue&type=template&id=008ab7f6"
import script from "./TheContactPage.vue?vue&type=script&lang=js"
export * from "./TheContactPage.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__